$(function(){
  var componentRequireContext = require.context('components', true);
  var ReactRailsUJS = require('react_ujs');
  ReactRailsUJS.useContext(componentRequireContext);
  ReactRailsUJS.mountComponents();
});




// WEBPACK FOOTER //
// ./app/javascript/lib/ujs.js